import { MatDialog } from '@angular/material/dialog';
import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ViewChildren, } from '@angular/core';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Observable, Subject } from 'rxjs';
import { CommonService } from 'src/app/core/services/common.service';
import { NotifierService } from 'angular-notifier';
import { BaseComponent } from 'src/app/shared/components/base/base.component';

import { map, startWith } from 'rxjs/operators';
import { Message } from 'src/app/core/class/message';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import Handsontable from 'handsontable';
import { ItemCategory } from 'src/app/shared/models/item-category.model';
import { GeneralCategory } from 'src/app/shared/models/general-category.model';
import { MasterDataTypeService } from 'src/app/core/services/master-data-type.service';
import { MasterDataService } from 'src/app/core/services/master-data.service';
import { Location } from '@angular/common';
import { ErrorCode } from '../../../../../../core/constants/error-code';
import { query } from '@angular/animations';

@Component({
  selector: 'app-add-category',
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.scss'],
})
export class AddCategoryComponent
  extends BaseComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren('focusInput') focusInput;
  @ViewChild('matSelect', { static: true }) matSelect;

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService,
    private activatedRouter: ActivatedRoute,
    public toast: ToastrService,
    private router: Router,
    private el: ElementRef,
    private masterDataTypeService: MasterDataTypeService,
    private masterDataService: MasterDataService,
    private location: Location
  ) {
    super(commonService, message);
    this.notifier = notifier;
  }

  mode: string = 'create';

  listItems: ItemCategory[] = [];

  category: GeneralCategory = GeneralCategory.build();

  handsontableInstance: Handsontable = null;

  categoryForm: FormGroup;

  totalRow: number = 1;

  listParents: {
    parentId: string;
    parentName: string;
  }[] = [];

  listParentsFilter: Observable<any>;

  searchParentCtrl: FormControl = new FormControl(null);
  loadingSearch: boolean = false;

  _onDestroy = new Subject<void>();

  timeOut: any = null;

  parentValueSource: string[] = [];

  noData: boolean = false;

  errorTable: boolean = false;

  currentParent: string;

  oldParent: string = null;

  parent: string = null;

  listItemsTemp: any = null;

  insertRow: boolean = false;

  ngOnInit() {
    this.initForm();
    const self = this;
    this.activatedRouter.paramMap.subscribe((params) => {
      const id = params.get('id') ? params.get('id') : null;
      if (id) {
        this.mode = 'update';
        this.getDataById(id);
      } else {
        this.mode = 'create';
        this.initTable(self.listItems);
        this.getListParent();
      }
    });

    this.initFormControlSearch();
  }

  ngOnDestroy(): void {
  }

  ngAfterViewInit(): void {
    this.focusInput.first.nativeElement.focus();
  }

  createDomByStringHtml(strHtml: string): Node {
    return new DOMParser().parseFromString(strHtml, 'text/html').body
      .childNodes[0];
  }

  initForm() {
    this.categoryForm = this.fb.group({
      name: new FormControl('', [Validators.required, Validators.maxLength(200)]),
      parent: new FormControl(''),
      description: new FormControl(''),
      codeContains: new FormControl(''),
      valueContains: new FormControl(''),
    });
  }

  get categoryControls() {
    return this.categoryForm.controls;
  }

  getDataById(id: string) {
    let self = this;
    this.masterDataTypeService.getCategoryById(id).subscribe((res) => {
      if (res.data) {
        self.category = res.data;
        self.oldParent = res.data.parentId;
        self.parent = res.data.parentId;
        if (res.data.items) {
          self.listItems = res.data.items;
          self.listItems.forEach((item) => {
            if (item.parentId) {
              item.parentCodeAndValue =
                item.parentCode + ' - ' + item.parentValue;
            }
          });
        }

        this.listItemsTemp = JSON.stringify(res.data.items);

        let temp = {
          parentId: res.data.parentId ? res.data.parentId : null,
          parentName: res.data.parentName ? res.data.parentName : null,
        };
        if (temp.parentId && temp.parentName) {
          let source = [null];
          this.masterDataTypeService
            .getCategoryById(temp.parentId)
            .subscribe((response) => {
              if (response && response.data) {
                if (response.data.items.length) {
                  response.data.items.forEach((item) => {
                    source.push(item.code + ' - ' + item.value);
                  });
                }
              }
            });
          self.parentValueSource = source;
        }
        self.categoryControls.name.patchValue(self.category.name);
        self.categoryControls.description.patchValue(self.category.description);
        self.categoryControls.parent.patchValue(self.category.parentId);

        self.totalRow = self.listItems.length ? self.listItems.length : 1;
        self.initTable(self.listItems);

        self.getListParent();
      } else {
        this.toast.error(
          this.message.getMessage('messages.category_not_permission')
        );
        this.location.back();
      }
    });
  }

  deleteItem(item: ItemCategory, value: string, id?: string) {
    let dataDialog = this.message.getMessage(
      'messages.confirm_delete_item_null'
    );
    if (value) {
      dataDialog = this.commonService.format(
        this.message.getMessage('messages.confirm_delete_item'),
        value
      );
    }
    const warnDialog = this.dialog.open(WarningComponent, {
      width: '40%',
      data: dataDialog,
    });
    let self = this;
    warnDialog.afterClosed().subscribe((res) => {
      if (res) {
        if (id) {
          this.masterDataService.checkDeleteRelation(id).subscribe((res) => {
            if (res.data === 'OK') {
              let index = this.listItems.indexOf(item);
              if (index !== -1) {
                self.toast.success(
                  self.message.getMessage('messages.delete_item_success')
                );
                if (self.totalRow > 0) {
                  self.totalRow -= 1;
                }
                self.listItems.splice(index, 1);
                self.initTable(self.listItems);
                this.handsontableInstance.refreshDimensions();
                this.handsontableInstance.render();
                // self.handsontableInstance.alter("remove_row", index);
              }
            } else {
              switch (res.code) {
                case ErrorCode.MasterDataBlock:
                  if (item.value) {
                    self.toast.error(
                      self.commonService.format(
                        self.message.getMessage(
                          'messages.delete_item_has_value'
                        ),
                        item.code,
                        item.value
                      )
                    );
                  } else {
                    self.toast.error(
                      self.message.getMessage(
                        'messages.delete_item_error_null_value'
                      )
                    );
                  }
                  break;
                case ErrorCode.MasterDataDocumentTemplateBlock:
                  self.toast.error(
                    self.message.getMessage(
                      'messages.delete_item_document_template_error'
                    )
                  );
                  break;
                case ErrorCode.MasterDataNotfound:
                  self.toast.error(
                    self.message.getMessage('messages.delete_item_not_found')
                  );
                  break;
              }
            }
          });
        } else {
          let index = self.listItems.indexOf(item);
          if (index !== -1) {
            self.toast.success(
              self.message.getMessage('messages.delete_item_success')
            );
            if (self.totalRow > 0) {
              self.totalRow -= 1;
            }
            // self.initTable(self.listItems);
            self.handsontableInstance.alter('remove_row', index);
            // self.listItems.splice(index, 1);
          }
        }
      }
    });
  }

  initTable(dataTable: any[]) {
    const self = this;

    if (
      this.handsontableInstance &&
      this.handsontableInstance.isDestroyed !== true
    ) {
      this.handsontableInstance.destroy();
    }
    const container = document.getElementById('tableContractId');

    const configTable: Handsontable.GridSettings = {
      licenseKey: 'non-commercial-and-evaluation',
      colHeaders: [
        this.message.getMessage('general_category.titleCode'),
        this.message.getMessage('general_category.titleValue'),
        this.message.getMessage('general_category.titleRefParent'),
        this.message.getMessage('general_category.titleAction'),
      ],
      rowHeaders: true,
      rowHeights: '51px',
      columnHeaderHeight: 50,
      width: '100%',
      height: '300px',
      // enterMoves: {col: 1, row: 0},
      className: 'htCenter htMiddle',
      stretchH: 'all',
      minRows: this.totalRow,
      manualColumnResize: false,
      copyable: true,
      copyPaste: true,
      columnSorting: false,
      persistentState: true,
      currentRowClassName: 'currentRow',
      colWidths: [140, 140, 140, 80],
      contextMenu: ['copy'],
      data: dataTable,
      // afterValidate: this.afterValidateForCode,
      afterChange: this.afterChangeHandsontable,
      afterSetCellMeta: this.afterSetCellMeta,
      beforePaste: this.beforePaste(dataTable),
      outsideClickDeselects: false,
      columns: [
        {
          data: 'code',
          readOnly: false,
          // validator: this.cellValidatorForCode,
          placeholder: `${this.message.getMessage(
            'general_category.codeInput'
          )}`,
        },
        {
          data: 'value',
          readOnly: false,
          // validator: this.cellValidatorValue,
          placeholder: `${this.message.getMessage(
            'general_category.valueInput'
          )}`,
        },
        {
          data: 'parentCodeAndValue',
          type: 'autocomplete',
          filter: false,
          strict: true,
          allowInvalid: false,
          source: this.parentValueSource,
          readOnly: !(
            this.parentValueSource && this.parentValueSource.length > 0
          ),
          placeholder: `${this.message.getMessage(
            'general_category.chooseInput'
          )}`
        },
        {
          data: 'action',
          readOnly: true,
          renderer: (instance, td, row, col, prop, value, cellProperties) => {
            td.className = 'htCenter htMiddle';

            const divWrap: Node = self.createDomByStringHtml(
              `<div class="d-flex justify-content-center" style="height: 30px;"></div>`
            );
            let titleTooltipDelete = this.message.getMessage(
              'general_category.tooltip_delete'
            );
            const btnDel: Node = self.createDomByStringHtml(`
              <button
                  class="mat-icon-button del"
                  type="button"
                  color="primary"
                  style="position: absolute"
              >
                <i
                  class="fa fa-trash"
                  style="font-size: 20px; margin-top: 5px"
                ></i>
                <span class="tooltiptext">${titleTooltipDelete}</span>
              </button>
              `);

            btnDel.addEventListener('click', (e) => {
              e.preventDefault();
              const item = this.listItems[row];
              const value = self.handsontableInstance.getDataAtCell(row, 1);
              if (this.listItems[row].id) {
                self.deleteItem(item, value, this.listItems[row].id);
              } else {
                self.deleteItem(item, value);
              }
            });

            divWrap.appendChild(btnDel);

            Handsontable.dom.empty(td);
            td.appendChild(divWrap);
          },
        },
      ],
    };
    this.handsontableInstance = new Handsontable(container!, configTable);
    this.handsontableInstance.render();
  }

  clearData(field: string) {
    let itemCategory = this.listItems.find((value) => {
      return !!value.parentCodeAndValue;
    });
    setTimeout(() => {
      if (field === 'parent') {
        this.matSelect.close();
        if (itemCategory) {
          const dialogRef = this.dialog.open(WarningComponent, {
            width: '40%',
            data:
              this.mode === 'create'
                ? this.message.getMessage(
                  'messages.confirm_change_parent_case_create'
                )
                : this.message.getMessage(
                  'messages.confirm_change_category_parent'
                ),
          });
          dialogRef.afterClosed().subscribe((rs) => {
            if (rs) {
              this.categoryForm.get(field).patchValue(null);
              this.listItems = this.listItems.map((value) => {
                value.parentCodeAndValue = null;
                value.parentId = null;
                value.parentValue = null;
                return value;
              });
              this.parentValueSource = [];
              this.initTable(this.listItems);
            } else {
              this.categoryControls.parent.patchValue(this.oldParent);
            }
          });
        } else {
          this.categoryForm.get(field).patchValue(null);
          this.parentValueSource = [];
          this.initTable(this.listItems);
        }
      } else {
        this.categoryForm.get(field).patchValue(null);
      }
      this.categoryForm.get(field).patchValue(null);
      if (field === 'codeContains' || field === 'valueContains') {
        this.filterTable();
      }
    }, 50);
  }

  filterTable() {
    this.noData = false;
    let rowHidden: number[] = [];
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }
    if (
      !this.categoryControls.codeContains.value &&
      !this.categoryControls.valueContains.value
    ) {
      this.handsontableInstance.updateSettings({
        hiddenRows: false,
      });
      return;
    }

    if (this.listItems.length) {
      this.timeOut = setTimeout(() => {
        let dataTemp = [];
        const codeFind = this.categoryControls.codeContains.value
          ? this.removeVietnameseTones(
            this.categoryControls.codeContains.value.trim()
          ).toLowerCase()
          : null;
        const valueFind = this.categoryControls.valueContains.value
          ? this.removeVietnameseTones(
            this.categoryControls.valueContains.value.trim()
          ).toLowerCase()
          : null;

        for (let i = 0; i < this.listItems.length; i++) {
          const config = JSON.parse(JSON.stringify(this.listItems[i]));
          const codeItem = config.code
            ? this.removeVietnameseTones(config.code.trim()).toLowerCase()
            : null;
          const valueItem = config.value
            ? this.removeVietnameseTones(config.value.trim()).toLowerCase()
            : null;
          if (!codeFind && valueItem && valueItem.includes(valueFind)) {
            dataTemp.push(this.listItems[i]);
          } else if (!valueFind && codeItem && codeItem.includes(codeFind)) {
            dataTemp.push(this.listItems[i]);
          } else if (
            valueItem &&
            codeItem &&
            codeItem.includes(codeFind) &&
            valueItem.includes(valueFind)
          ) {
            dataTemp.push(this.listItems[i]);
          } else {
            rowHidden.push(i);
          }
        }
        this.handsontableInstance.updateSettings({
          hiddenRows: { rows: rowHidden },
        });
        if (rowHidden.length === this.listItems.length) {
          this.noData = true;
        }
      });
    }
  }

  createNewItem() {
    setTimeout(() => {
      if (
        this.categoryControls.codeContains.value ||
        this.categoryControls.valueContains.value
      ) {
        this.totalRow = this.listItems.length;
        this.categoryControls.codeContains.patchValue(null);
        this.categoryControls.valueContains.patchValue(null);
        this.initTable(this.listItems);
      }
      this.handsontableInstance.updateSettings({
        hiddenRows: false,
      });
      this.totalRow = this.listItems.length + 1;
      this.handsontableInstance.alter('insert_row');
      // this.initTable(this.listItems);
      this.handsontableInstance.selectCell(
        this.totalRow - 1,
        0,
        this.totalRow - 1,
        0,
        true
      );
      this.handsontableInstance.refreshDimensions();
      this.handsontableInstance.render();
    });
  }

  async saveCategory() {
    setTimeout(async () => {
      // let checkExistName = false;
      this.saveDataToObject(this.category);
      let category = {
        name: '',
        codeOrValue: '',
        parentId: this.parent,
        page: 0,
        size: 10,
      };
      // let masterDataTypes = await this.masterDataTypeService
      //   .getCategory(category)
      //   .toPromise();
      // if (masterDataTypes && masterDataTypes.data && masterDataTypes.data.content) {
      //   masterDataTypes.data.content.forEach(masterDataType => {
      //     if (this.category.id && this.category.id !== masterDataType.id
      //       && this.removeVietnameseTones(this.category.name.toLowerCase()) === this.removeVietnameseTones(masterDataType.name.toLowerCase())) {
      //       checkExistName = true;
      //     }
      //   })
      // }

      // if (checkExistName) {
      //   this.categoryControls.name.setErrors({ exist: true });
      //   this.focusInput.first.nativeElement.focus();
      //   return;
      // }

      await this.checkErrorTable();

      if (this.errorTable) {
        return;
      }

      if (this.categoryForm.invalid) {
        this.categoryForm.markAllAsTouched();
        return;
      }


      if (this.categoryControls.parent.value) {
        this.masterDataTypeService
          .getCategoryById(this.categoryControls.parent.value)
          .subscribe((res) => {
            if (res.data && res.data.items) {
              let listCode = [];
              let parentValueInvalid = [];
              res.data.items.forEach((item) => {
                listCode.push(item.code);
              });
              for (let i = 0; i < this.listItems.length; i++) {
                if (this.listItems[i].parentCodeAndValue) {
                  let arr = this.listItems[i].parentCodeAndValue.split(' - ');
                  this.listItems[i].parentCode = arr[0];
                  this.listItems[i].parentValue = arr[1];
                  let index = listCode.indexOf(arr[0]);
                  if (index !== -1) {
                    this.listItems[i].parentId =
                      res.data.items[listCode.indexOf(arr[0])].id;
                  } else {
                    parentValueInvalid.push(arr[1]);
                  }
                } else {
                  this.listItems[i].parentCode = null;
                  this.listItems[i].parentId = null;
                }
              }

              if (parentValueInvalid && parentValueInvalid.length) {
                parentValueInvalid = Array.from(new Set(parentValueInvalid));
                this.toast.error(
                  this.commonService.format(
                    this.message.getMessage(
                      'general_category.item_parentValue_invalid'
                    ),
                    parentValueInvalid.join(', ')
                  )
                );
                return;
              } else {
                // this.listItems.forEach((item) => {
                //   delete item.parentCodeAndValue;
                // });
              }

              if (this.mode === 'create') {
                this.createCategory();
              } else {
                this.updateCategory();
              }
            } else {
              const categoryParent = this.listParents.find((value) => {
                return value.parentId === this.categoryControls.parent.value;
              });

              this.toast.error(
                this.commonService.format(
                  this.message.getMessage('messages.category_not_found'),
                  categoryParent.parentName
                )
              );
            }
          });
      } else {
        if (this.mode === 'create') {
          this.createCategory();
        } else {
          this.updateCategory();
        }
      }
    }, 500);
  }

  saveDataToObject(object: GeneralCategory): GeneralCategory {
    let listItemsDataSplice: ItemCategory[] = [];
    if (this.listItems.length) {
      for (let i = 0; i < this.listItems.length; i++) {
        if (
          (this.listItems[i].code &&
            (this.listItems[i].code != null ||
              this.listItems[i].code !== '')) ||
          (this.listItems[i].value &&
            (this.listItems[i].value != null ||
              this.listItems[i].value !== '')) ||
          (this.listItems[i].parentCodeAndValue &&
            (this.listItems[i].parentCodeAndValue != null ||
              this.listItems[i].parentCodeAndValue !== ''))
        ) {
          listItemsDataSplice.push(this.listItems[i]);
        }
      }
    }
    object.name = this.categoryControls.name.value;
    if (this.categoryControls.parent.value) {
      object.parentId = this.categoryControls.parent.value;
      object.parentName = this.listParents.find((parent) => {
        return parent.parentId === object.parentId;
      }).parentName;
    } else {
      object.parentId = null;
      object.parentName = null;
    }

    object.description = this.categoryControls.description.value;
    object.items = listItemsDataSplice;
    return object;
  }

  async updateCategory() {
    let category = {
      name: '',
      codeOrValue: '',
      parentId: this.parent,
      page: 0,
      size: 10,
    };
    let temp = await this.masterDataTypeService
      .getCategory(category)
      .toPromise();
    this.masterDataTypeService
      .updateCategory(this.category)
      .subscribe((res) => {
        if (res.code === ErrorCode.MasterDataTypeDuplicateName) {
          this.categoryControls.name.setErrors({ exist: true });
          this.focusInput.first.nativeElement.focus();
          return;
        }
        if (res.code === ErrorCode.MasterDataTypeNotFound) {
          this.toast.error(
            this.message.getMessage('messages.update_category_not_found_error')
          );
          if (!window.history.length) {
            this.router.navigateByUrl('/home-enterprise/general-category');
          } else {
            this.location.back();
          }
          return;
        }
        if (res.code === ErrorCode.MasterDataNotfound) {
          this.toast.error(
            this.message.getMessage('messages.delete_category_not_found_error')
          );
          if (!window.history.length) {
            this.router.navigateByUrl('/home-enterprise/general-category');
          } else {
            this.location.back();
          }
          return;
        }

        if (!res || !res.data) {
          this.toast.error(
            this.message.getMessage('messages.update_category_error')
          );
          return;
        }

        if (
          !window.history.length ||
          (temp && temp.data && temp.data.total === 1)
        ) {
          this.router.navigateByUrl('/home-enterprise/general-category');
        } else {
          this.location.back();
        }

        this.toast.success(
          this.message.getMessage('messages.update_category_success')
        );
      });
  }

  createCategory() {
    this.masterDataTypeService
      .createCategory(this.category)
      .subscribe((res) => {
        if (res.code === ErrorCode.MasterDataTypeDuplicateName) {
          this.categoryControls.name.setErrors({ exist: true });
          this.focusInput.first.nativeElement.focus();
          return;
        }

        if (!res || !res.data) {
          this.toast.error(
            this.message.getMessage('messages.add_category_error')
          );
          return;
        }

        if (!window.history.length) {
          this.router.navigateByUrl('/home-enterprise/general-category');
        } else {
          this.location.back();
        }

        this.toast.success(
          this.message.getMessage('messages.add_category_success')
        );
      });
  }

  async checkErrorTable() {
    this.handsontableInstance.deselectCell();

    this.errorTable = false;
    let duplicateCode = [];
    const duplicateParent = [];
    for (let i = 0; i < this.listItems.length; i++) {
      if (
        (!this.listItems[i].code || this.listItems[i].code.trim() === '') &&
        (this.listItems[i].parentCodeAndValue || this.listItems[i].value)
      ) {
        this.toast.error(
          this.message.getMessage('general_category.code_required')
        );
        this.errorTable = true;
        this.handsontableInstance.selectCell(i, 0, i, 0, true);
        this.handsontableInstance.setCellMeta(i, 0, 'valid', false);
        this.handsontableInstance.render();
        return;
      } else if (
        this.listItems[i].code &&
        this.listItems[i].code.includes(' ')
      ) {
        this.toast.error(
          this.message.getMessage('general_category.space_exist')
        );
        this.errorTable = true;
        this.handsontableInstance.selectCell(i, 0, i, 0, true);
        this.handsontableInstance.setCellMeta(i, 0, 'valid', false);
        this.handsontableInstance.render();
        return;
      } else if (
        this.listItems[i].code &&
        this.listItems[i].code.length > 200
      ) {
        this.toast.error(
          this.message.getMessage('general_category.maxlength_code')
        );
        this.errorTable = true;
        this.handsontableInstance.selectCell(i, 0, i, 0, true);
        this.handsontableInstance.setCellMeta(i, 0, 'valid', false);
        this.handsontableInstance.render();
        return;
      }
      //  else if (
      //   this.listItems[i].code &&
      //   this.listItems[i].code.includes('\n')
      // ) {
      //   this.toast.error(
      //     this.message.getMessage('general_category.data_invalid')
      //   );
      //   this.errorTable = true;
      //   this.handsontableInstance.selectCell(i, 0, i, 0, true);
      //   this.handsontableInstance.setCellMeta(i, 0, 'valid', false);
      //   this.handsontableInstance.render();
      //   return;
      // }

      if (
        (!this.listItems[i].value || this.listItems[i].value.trim() === '') &&
        (this.listItems[i].parentCodeAndValue || this.listItems[i].code)
      ) {
        this.toast.error(
          this.message.getMessage('general_category.value_required')
        );
        this.errorTable = true;
        this.handsontableInstance.selectCell(i, 1, i, 1, true);
        this.handsontableInstance.setCellMeta(i, 1, 'valid', false);
        this.handsontableInstance.render();
        return;
      } else if (
        this.listItems[i].value &&
        this.listItems[i].value.length > 200
      ) {
        this.toast.error(
          this.message.getMessage('general_category.maxlength_value')
        );
        this.errorTable = true;
        this.handsontableInstance.selectCell(i, 1, i, 1, true);
        this.handsontableInstance.setCellMeta(i, 1, 'valid', false);
        this.handsontableInstance.render();
        return;
      }
      //  else if (
      //   this.listItems[i].value &&
      //   this.listItems[i].value.includes('\n')
      // ) {
      //   this.toast.error(
      //     this.message.getMessage('general_category.data_invalid')
      //   );
      //   this.errorTable = true;
      //   this.handsontableInstance.selectCell(i, 1, i, 1, true);
      //   this.handsontableInstance.setCellMeta(i, 1, 'valid', false);
      //   this.handsontableInstance.render();
      //   return;
      // }

      const isDuplicateCode = this.listItems.find((value, index) => {
        return (
          i !== index &&
          this.listItems[i].code && value && value.code &&
          this.listItems[i].code.toUpperCase() == value.code.toUpperCase()
        );
      });
      if (isDuplicateCode) {
        this.handsontableInstance.setCellMeta(i, 0, 'valid', false);
      }

      // Todo check duplicate item category_code
      if (isDuplicateCode && !duplicateCode.map(item => item.toUpperCase()).includes(this.listItems[i].code.toUpperCase())) {
        duplicateCode.push(this.listItems[i].code);
      }

      if (this.listItems[i].parentCodeAndValue) {
        const findMatchParent = this.listItems.filter((item, indexRow) => {
          return item.parentCodeAndValue === this.listItems[i].parentCodeAndValue && indexRow !== i
        });
        const valueAndCode = this.listItems[i].parentCodeAndValue.split('-');
        const value = valueAndCode.length >= 2 ? valueAndCode[1] : '';
        if (findMatchParent.length > 0) {
          if (!duplicateParent.includes(value)) {
            duplicateParent.push(value);
          }
          this.handsontableInstance.setDataAtCell(i, 2, this.listItems[i].parentCodeAndValue);
        }
      }
    }

    if (duplicateCode && duplicateCode.length) {
      this.toast.error(
        this.commonService.formatString(
          this.message.getMessage('general_category.item_duplicate_code'),
          duplicateCode.join(', ')
        )
      );
      this.errorTable = true;
      this.handsontableInstance.render();
      return;
    }

    if (duplicateParent.length) {
      this.toast.error(
        this.commonService.formatString(
          this.message.getMessage('general_category.duplicate_parrent'),
          duplicateParent.join(', ')
        )
      );
      this.errorTable = true;
      this.handsontableInstance.render();
      return;
    }

    // Todo check delete item category
    for (let i = 0; i < this.listItems.length; i++) {
      if (
        !this.listItems[i].code &&
        !this.listItems[i].value &&
        !this.listItems[i].parentCodeAndValue
      ) {
        if (this.listItems[i].id) {
          let checkDeleteItemCategory = await this.masterDataService
            .checkDeleteRelation(this.listItems[i].id)
            .toPromise();
          if (
            checkDeleteItemCategory &&
            checkDeleteItemCategory.data !== 'OK'
          ) {
            this.errorTable = true;
            switch (checkDeleteItemCategory.code) {
              case ErrorCode.MasterDataBlock:
                if (this.listItems[i].value) {
                  this.toast.error(
                    this.commonService.format(
                      this.message.getMessage('messages.delete_item_error'),
                      this.listItems[i].value
                    )
                  );
                } else {
                  this.toast.error(
                    this.message.getMessage(
                      'messages.delete_item_error_null_value'
                    )
                  );
                }
                break;
              case ErrorCode.MasterDataDocumentTemplateBlock:
                this.toast.error(
                  this.message.getMessage(
                    'messages.delete_item_document_template_error'
                  )
                );
                break;
              case ErrorCode.MasterDataNotfound:
                this.toast.error(
                  this.commonService.format(
                    this.message.getMessage('messages.delete_item_not_found'),
                    this.listItems[i].value
                  )
                );
                break;
            }
            break;
          }
        }
      }
    }
  }

  initFormControlSearch() {
    this.listParentsFilter = this.searchParentCtrl.valueChanges.pipe(
      startWith(''),
      map((value) => {
        if (!value) {
          return this.listParents;
        }
        return this.listParents.filter((st) => {
          const optionLabel = `${st.parentName}`;
          return optionLabel.toLowerCase().includes(value.trim().toLowerCase());
        });
      })
    );
  }

  getListParent() {
    this.listParents = [];
    const request = {
      name: '',
      codeOrValue: '',
      parentId: null,
      page: 0,
      size: 1000,
    };
    this.masterDataTypeService.getCategory(request).subscribe((res) => {
      if (res.data && res.data.content.length) {
        res.data.content.forEach((item) => {
          let temp = {
            parentId: '',
            parentName: '',
          };
          if (item.name && item.name !== this.category.name) {
            temp.parentName = item.name;
            if (item.id) {
              temp.parentId = item.id;
            }
            this.listParents.push(temp);
          }
        });
        this.listParents = this.listParents.sort((a, b) => {
          return a.parentName.localeCompare(b.parentName);
        });
      }
      this.searchParentCtrl.patchValue('');
    });
  }

  cancel() {
    setTimeout(() => {
      let checkItemChange = false;
      if (this.mode === 'create') {
        if (this.listItems.length) {
          this.listItems.forEach((item) => {
            if (item.code || item.value || item.parentCodeAndValue) {
              checkItemChange = true;
            }
          });
        }
      } else {
        checkItemChange = !(
          JSON.stringify(this.listItems) === this.listItemsTemp
        );
      }
      if (!this.categoryForm.dirty && !checkItemChange) {
        if (!window.history.length) {
          this.router.navigateByUrl('/home-enterprise/general-category');
        } else {
          this.location.back();
        }
      } else {
        const dialog = this.dialog.open(WarningComponent, {
          width: '40%',
          data: this.message.getMessage('messages.confirm_cancel'),
        });
        dialog.afterClosed().subscribe((res) => {
          if (res) {
            if (!window.history.length) {
              this.router.navigateByUrl('/home-enterprise/general-category');
            } else {
              this.location.back();
            }
          }
        });
      }
    }, 500);
  }

  removeVietnameseTones(str) {
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    str = str.replace(/đ/g, 'd');
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
    str = str.replace(/Đ/g, 'D');
    // Some system encode vietnamese combining accent as individual utf-8 characters
    // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ''); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
    str = str.replace(/\u02C6|\u0306|\u031B/g, ''); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
    // Remove extra spaces
    // Bỏ các khoảng trắng liền nhau
    // str = str.replace(/ + /g, ' ');
    str = str.trim();
    return str;
  }

  focusOut(field: string) {
    const value = this.categoryForm.get(field).value
      ? this.categoryForm.get(field).value.trim()
      : null;
    this.categoryForm.get(field).patchValue(value);
  }

  afterChangeHandsontable = (changes) => {
    if (changes) {
      changes.forEach(([row, prop, oldValue, currentValue]) => {
        let dataCellParent = this.handsontableInstance.getDataAtCell(row, 2);
        let rowCodeValue = this.handsontableInstance.getDataAtCell(row, 0);
        switch (prop) {
          case 'code':
            if (currentValue) {
              if (currentValue.startsWith(' ') || currentValue.endsWith(' ')) {
                this.handsontableInstance.setDataAtCell(row, 0, currentValue.trim());
              // } else if (currentValue.includes(' ') || currentValue.includes('\n')) {
              //   this.handsontableInstance.setCellMeta(row, 0, 'valid', false);
              } else if (currentValue.length > 200) {
                this.handsontableInstance.setDataAtCell(row, 0, currentValue.substring(0, 199));
              } else {
                let hasDuplicateCode = false;
                let rowIndexDuplicateCode = [];
                this.listItems.forEach((value, index) => {
                  if (row !== index && value && value.code &&
                    currentValue.toUpperCase() === value.code.toUpperCase()) {
                    hasDuplicateCode = true;
                    rowIndexDuplicateCode.push(index);
                  }
                });
                if (hasDuplicateCode) {
                  rowIndexDuplicateCode.forEach((value) => {
                    this.handsontableInstance.setCellMeta(row, 0, 'valid', false);
                    this.handsontableInstance.setCellMeta(value, 0, 'valid', false);
                  });
                } else {
                  this.handsontableInstance.setCellMeta(row, 0, 'valid', true);
                }
                if (oldValue != currentValue) {
                  const itemMatchOldValue = [];
                  this.listItems.forEach((value, index) => {
                    if (value.code == oldValue) {
                      itemMatchOldValue.push(index);
                    }
                  });
                  if (itemMatchOldValue.length === 1) {
                    this.handsontableInstance.setCellMeta(itemMatchOldValue[0], 0, 'valid', true);
                  }
                }
              }
            } else {
              let dataCellValue = this.handsontableInstance.getDataAtCell(row, 1);
              if (!currentValue && (dataCellValue || dataCellParent)) {
                this.handsontableInstance.setCellMeta(row, 0, 'valid', false);
              } else if (!currentValue && !dataCellValue && !dataCellParent) {
                this.handsontableInstance.setCellMeta(row, 1, 'valid', true);
                this.handsontableInstance.setCellMeta(row, 0, 'valid', true);
              }
              if (oldValue != currentValue) {
                const itemMatchOldValue = [];
                this.listItems.forEach((value, index) => {
                  if (value.code == oldValue) {
                    itemMatchOldValue.push(index);
                  }
                });
                if (itemMatchOldValue.length === 1) {
                  this.handsontableInstance.setCellMeta(itemMatchOldValue[0], 0, 'valid', true);
                }
              }
            }
            break;
          case 'value':
            if (rowCodeValue) {
              let hasDuplicateCode = false;
              let rowIndexDuplicateCode = [];
              this.listItems.forEach((value, index) => {
                if (row !== index && value && value.code &&
                  rowCodeValue.toUpperCase() === value.code.toUpperCase()) {
                  hasDuplicateCode = true;
                  rowIndexDuplicateCode.push(index);
                }
              });
              if (hasDuplicateCode) {
                rowIndexDuplicateCode.forEach((value) => {
                  this.handsontableInstance.setCellMeta(row, 0, 'valid', false);
                  this.handsontableInstance.setCellMeta(value, 0, 'valid', false);
                });
              } else {
                this.handsontableInstance.setCellMeta(row, 0, 'valid', true);
              }
            }
            if (currentValue) {
              if (currentValue.startsWith(' ') || currentValue.endsWith(' ')) {
                this.handsontableInstance.setDataAtCell(row, 0, currentValue.trim());
              // } else if (currentValue.includes('\n')) {
              //   this.handsontableInstance.setCellMeta(row, 1, 'valid', false);
              } else if (currentValue.length > 200) {
                this.handsontableInstance.setDataAtCell(row, 1, currentValue.substring(0, 199));
              } else {
                this.handsontableInstance.setCellMeta(row, 1, 'valid', true);
              }
            } else {
              let dataCellCode = this.handsontableInstance.getDataAtCell(row, 0);
              if (!currentValue && (dataCellCode || dataCellParent)) {
                this.handsontableInstance.setCellMeta(row, 1, 'valid', false);
              } else if (!currentValue && !dataCellCode && !dataCellParent) {
                this.handsontableInstance.setCellMeta(row, 0, 'valid', true);
                this.handsontableInstance.setCellMeta(row, 1, 'valid', true);
              }
            }
            break;
          case 'parentCodeAndValue':
            if (rowCodeValue) {
              let hasDuplicateCode = false;
              let rowIndexDuplicateCode = [];
              let rowIndexDuplicateParent = [];
              let rowIndexMatchOldParent = [];
              this.listItems.forEach((value, index) => {
                if (row !== index && value && value.code &&
                  rowCodeValue.toUpperCase() === value.code.toUpperCase()) {
                  hasDuplicateCode = true;
                  rowIndexDuplicateCode.push(index);
                }
                if (row !== index && value && value.parentCodeAndValue && value.parentCodeAndValue === currentValue) {
                  rowIndexDuplicateParent.push(index);
                }
                if (row !== index && value && value.parentCodeAndValue && value.parentCodeAndValue === oldValue && oldValue !== currentValue) {
                  rowIndexMatchOldParent.push(index);
                }
              });
              if (hasDuplicateCode) {
                rowIndexDuplicateCode.forEach((value) => {
                  this.handsontableInstance.setCellMeta(row, 0, 'valid', false);
                  this.handsontableInstance.setCellMeta(value, 0, 'valid', false);
                });
              } else {
                this.handsontableInstance.setCellMeta(row, 0, 'valid', true);
              }
              if (rowIndexDuplicateParent.length) {
                this.handsontableInstance.setCellMeta(row, 2, 'valid', false);
                rowIndexDuplicateParent.forEach(indexDup => {
                  this.handsontableInstance.setCellMeta(indexDup, 2, 'valid', false);
                });
              } else {
                this.handsontableInstance.setCellMeta(row, 2, 'valid', true);
              }
              if (rowIndexMatchOldParent.length === 1) {
                this.handsontableInstance.setCellMeta(rowIndexMatchOldParent[0], 2, 'valid', true);
              }
            }
            let dataCellValue = this.handsontableInstance.getDataAtCell(row, 1);
            let dataCellCode = this.handsontableInstance.getDataAtCell(row, 0);
            if (currentValue) {
              if (!dataCellCode) {
                this.handsontableInstance.setCellMeta(row, 0, 'valid', false);
              }
              if (!dataCellValue) {
                this.handsontableInstance.setCellMeta(row, 1, 'valid', false);
              }
            } else {
              if (!dataCellValue && !dataCellCode) {
                this.handsontableInstance.setCellMeta(row, 0, 'valid', true);
                this.handsontableInstance.setCellMeta(row, 1, 'valid', true);
              }
            }
            break;
        }
      });
      this.handsontableInstance.render();
    }
    if (this.categoryControls.codeContains.value || this.categoryControls.valueContains.value) {
      this.filterTable();
    }
  };
  afterSetCellMeta = (row, column, key, value) => {
    if (column != 0) {
      let rowCodeValue = this.handsontableInstance.getDataAtCell(row, 0);
      if (rowCodeValue) {
        let hasDuplicateCode = false;
        let rowIndexDuplicateCode = [];
        this.listItems.forEach((value, index) => {
          if (row !== index && value && value.code &&
            rowCodeValue.toUpperCase() === value.code.toUpperCase()) {
            hasDuplicateCode = true;
            rowIndexDuplicateCode.push(index);
          }
        });
        if (hasDuplicateCode) {
          rowIndexDuplicateCode.forEach((value) => {
            this.handsontableInstance.setCellMeta(row, 0, 'valid', false);
            this.handsontableInstance.setCellMeta(value, 0, 'valid', false);
          });
        } else {
          this.handsontableInstance.setCellMeta(row, 0, 'valid', true);
        }
      }
    }
  };

  afterValidateForCode = (isValid, value, row, prop, source) => {
    if (isValid) {
      let dataCellParent = this.handsontableInstance.getDataAtCell(row, 2);
      switch (prop) {
        case 'code':
          let dataCellValue = this.handsontableInstance.getDataAtCell(row, 1);
          if (!value && (dataCellValue || dataCellParent)) {
            isValid = false;
          } else if (!value && !dataCellValue && !dataCellParent) {
            isValid = true;
            this.handsontableInstance.setCellMeta(row, 1, 'valid', true);
          }
          break;
        case 'value':
          let dataCellCode = this.handsontableInstance.getDataAtCell(row, 0);
          if (!value && (dataCellCode || dataCellParent)) {
            isValid = false;
          } else if (!value && !dataCellCode && !dataCellParent) {
            isValid = true;
            this.handsontableInstance.setCellMeta(row, 0, 'valid', true);
          }
          break;
      }
    }
    return isValid;
  };

  onChangeParent(event) {
    let itemCategory = this.listItems.find((value) => {
      return !!value.parentCodeAndValue;
    });
    if (itemCategory) {
      const dialogRef = this.dialog.open(WarningComponent, {
        width: '40%',
        data:
          this.mode === 'create'
            ? this.message.getMessage(
              'messages.confirm_change_parent_case_create'
            )
            : this.message.getMessage(
              'messages.confirm_change_category_parent'
            ),
      });
      dialogRef.afterClosed().subscribe((rs) => {
        if (rs) {
          if (event.value) {
            this.currentParent = event.value;
            let source = [];
            this.masterDataTypeService
              .getCategoryById(event.value)
              .subscribe((response) => {
                if (response && response.data) {
                  this.listItems = this.listItems.map((value) => {
                    value.parentCodeAndValue = null;
                    value.parentId = null;
                    value.parentValue = null;
                    return value;
                  });
                  this.oldParent = event.value;
                  if (response.data.items.length) {
                    response.data.items.forEach((item) => {
                      source.push(item.code + ' - ' + item.value);
                    });
                  }
                  this.parentValueSource = source;
                  this.initTable(this.listItems);
                } else {
                  this.categoryControls.parent.patchValue(this.oldParent);
                  const categoryParent = this.listParents.find((value) => {
                    return value.parentId === event.value;
                  });

                  this.toast.error(
                    this.commonService.format(
                      this.message.getMessage('messages.category_not_found'),
                      categoryParent.parentName
                    )
                  );
                  this.parentValueSource = null;
                }
              });
          } else {
            this.parentValueSource = null;
            this.initTable(this.listItems);
          }
        } else {
          this.categoryControls.parent.patchValue(this.oldParent);
        }
      });
    } else {
      if (event.value) {
        this.currentParent = event.value;
        let source = [];
        this.masterDataTypeService
          .getCategoryById(event.value)
          .subscribe((response) => {
            if (response && response.data) {
              this.listItems = this.listItems.map((value) => {
                value.parentCodeAndValue = null;
                value.parentId = null;
                value.parentValue = null;
                return value;
              });
              this.oldParent = event.value;
              if (response.data.items.length) {
                response.data.items.forEach((item) => {
                  source.push(item.code + ' - ' + item.value);
                });
              }
              this.parentValueSource = source;
              this.initTable(this.listItems);
            } else {
              this.categoryControls.parent.patchValue(this.oldParent);
              const categoryParent = this.listParents.find((value) => {
                return value.parentId === event.value;
              });

              this.toast.error(
                this.commonService.format(
                  this.message.getMessage('messages.category_not_found'),
                  categoryParent.parentName
                )
              );
              this.parentValueSource = null;
            }
          });
      }
    }
  }

  beforePaste(dataTable) {
    return (data, coords) => {
      if (coords.length && data.length + coords[0].endRow > dataTable.length) {
        const rowAdd = data.length + coords[0].endRow - dataTable.length;
        this.handsontableInstance.alter('insert_row', coords[0].endRow, rowAdd);
        const dataSet = [];
        data.forEach((row, index) => {
          row.forEach((value, indexCol) => {
            dataSet.push([coords[0].startRow + index, coords[0].startCol + indexCol, value]);
          })
        });
        this.handsontableInstance.setDataAtCell(dataSet);
        return false;
      }
    }
  }
}
